import { render, staticRenderFns } from "./bookctyactivities.vue?vue&type=template&id=b2dd5dae&scoped=true"
import script from "./bookctyactivities.vue?vue&type=script&lang=js"
export * from "./bookctyactivities.vue?vue&type=script&lang=js"
import style0 from "./bookctyactivities.vue?vue&type=style&index=0&id=b2dd5dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dd5dae",
  null
  
)

export default component.exports